import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import DailyPlanActions from "../../redux/dailyPlanRequest/actions";
import SimSwapActions from "../../redux/simSwapRequest/actions";
import ActivationRequestActions from "../../redux/activationRequest/actions";
import MSISDNPoolActions from "../../redux/msisdnPool/actions"
import { addData, getList } from '../../helpers/fackBackend_Helper';

const { getDailyPlanRequestSuccessful, getPendingDprCountdealerSuccess } = DailyPlanActions;
const { getSimSwapRequestSuccess } = SimSwapActions;
const { getActivationRequestListSuccessful } = ActivationRequestActions;
const { getMsisdnPoolSuccess } = MSISDNPoolActions;

function* getDailyPlanRequestForSocketResponse({ payload: { searchData } }) {
    const response = yield call(addData, '/dailyPlanRequestList', searchData);
    if (response.Status) {
        yield put(getDailyPlanRequestSuccessful(response.Data));
    }
}

function* getSIMSwapRequestForSocketResponse({ payload: { searchData } }) {
    const response = yield call(addData, '/simSwapRequestList', searchData);
    if (response.Status) {
        yield put(getSimSwapRequestSuccess(response.Data));
    }
}

function* getActivationRequestForSocketResponse({ payload: { searchData } }) {
    const response = yield call(addData, '/activationRequestList', searchData);
    if (response.Status) {
        yield put(getActivationRequestListSuccessful(response.activations));
    }
}

function* getMSisdnpoolForSocketResponse({ payload: { searchData } }) {
    const response = yield call(addData, '/getMsisdnPoolData', searchData);
    if (response.response.Status) {
        yield put(getMsisdnPoolSuccess(response.response.Data));
    }
}

function* getDPRPendingCountForSocketResponse() {
    const response = yield call(getList, '/getPendingDPRCountDealer');
    if (response.response.Status) {
        yield put(getPendingDprCountdealerSuccess(response.response.Data));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET, getDailyPlanRequestForSocketResponse)]);
    yield all([takeEvery(actions.GET_SIM_SWAP_REQUEST_FOR_SOCKET, getSIMSwapRequestForSocketResponse)]);
    yield all([takeEvery(actions.GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET, getActivationRequestForSocketResponse)]);
    yield all([takeEvery(actions.GET_MSISDN_POOL_DATA_FOR_SOCKET, getMSisdnpoolForSocketResponse)]);
    yield all([takeEvery(actions.GET_PENDING_DPRCOUNT_DEALER_SOCKET, getDPRPendingCountForSocketResponse)]);

}
